/**
 * Tradução de erros do Firebase Auth para pt-BR.
 * O Firebase devolve mensagens em inglês com o código embutido
 * (ex.: "Firebase: Error (auth/invalid-verification-code)."). Nunca exibir
 * `err.message` cru para o usuário — mapear pelo código e cair num fallback.
 */
const FIREBASE_AUTH_ERRORS_PTBR: Record<string, string> = {
  'invalid-verification-code': 'Código inválido. Confira os 6 dígitos e tente novamente.',
  'code-expired': 'Código expirado. Reenvie o SMS e use o código novo.',
  'too-many-requests': 'Muitas tentativas. Aguarde alguns minutos e tente de novo.',
  'invalid-phone-number': 'Número de telefone inválido.',
  'network-request-failed': 'Falha de conexão. Verifique sua internet.',
  'user-disabled': 'Esta conta foi desativada.',
  'user-not-found': 'Conta não encontrada.',
  'invalid-credential': 'Credenciais inválidas.',
};

export function mapFirebaseAuthError(err: unknown, fallback: string): string {
  const message = err instanceof Error ? err.message : '';
  for (const [code, ptbr] of Object.entries(FIREBASE_AUTH_ERRORS_PTBR)) {
    if (message.includes(code)) return ptbr;
  }
  return fallback;
}
